export const courses = [


    {
        course_id: "c000009",
        tought_by_teacher_id: "t00001",
        teacher_name: "John Easy",
        title: "NYSED Math 8th Grade",
        description: "This course is tought by an experience teacher with multipile certifications",
        standard: "NYSED",
        subject: "Mathematics",
        grade: "8",
        size: 1,
        reviews: 20,
        rating: 4.6,
        status: [
            "Open",
            // "Closed",
            // "Pending",
        ],
        price: 50,
        total_sessions: "10",

        registered_student_ids: [
            "s232199",
            "s232121",
            "s232100",
        ],
        course_start: "05-30-2020",
        course_end: "07-30-2020",
        time_of_week: [
            "Mon: 15:00",
            "Fri: 15:00",
        ],
        same_course_reviews: [
            {
                review_id: "c00001",
                comment: "John was a wonderful teacher.",
                score: 4,
                user_id: "p200051", //"p" is for parent, "s" is for student
            },
            {
                review_id: "c00002",
                comment: " A lot of home work",
                score: 2,
                user_id: "s250001", //"p" is for parent, "s" is for student
            },
        ]

    },

    {
        course_id: "c000010",
        tought_by_teacher_id: "t00002",
        teacher_name: "Tony Confusing",
        title: "NYSED ELA 10th Grade",
        description: "A confusing class",
        standard: "NYSED",
        subject: "ELA",
        grade: "10",
        size: 10,
        total_sessions: "flexible",
        reviews: 10,
        rating: 1.6,
        status: [
            "Open",
            // "Closed",
            // "Pending",
        ],
        price: 15,
        registered_student_ids: [
            "s232199",
            "s232121",
            "s232100",
        ],
        course_start: "05-30-2020",
        course_end: "07-30-2020",
        time_of_week: [
            "Mon: 18:00",
            "Thu: 18:00",
        ],
        same_course_reviews: [
            {
                review_id: "c00001",
                comment: "John was a wonderful teacher.",
                score: 4,
                user_id: "p200051", //"p" is for parent, "s" is for student
            },
            {
                review_id: "c00002",
                comment: " A lot of home work",
                score: 2,
                user_id: "s250001", //"p" is for parent, "s" is for student
            },
        ]

    },

];

export const teachers = [
    {
        teacher_id: "t00001",
        fname: "John",
        lname: "Easy",
        reviews: 25,
        rating: 4.6,
        certificates: [
            "NYSED: Mathematics 7-12 Professional Certificate",
            "NYSED: Teaching Assistant Level III",
        ],
        member_since: "01-01-2020",
        referral_credit: 305,
        open_courses_id: [
            "c000009",
        ],
        past_course_id: [
            "c000001",
        ],
        review_and_ratings: {//can be calculated with course ids
            rating: 4.7,
            reivews: [
                {
                    by_id: "",
                    comments: "",
                },
            ],
        },
    },
    {
        teacher_id: "t00002",
        fname: "Tony",
        lname: "Confusing",
        reviews: 25,
        rating: 0.3,
        certificates: [
            "NYSED: ELA 7-12 Professional Certificate",
            "NYSED: Teaching Assistant Level III",
        ],
        member_since: "01-01-2020",
        referral_credit: 305,
        open_courses_id: [
            "c0000010",
        ],
        past_course_id: [
            "c000007",
        ],
        review_and_ratings: {//can be calculated with course ids
            rating: 4.7,
            reivews: [
                {
                    by_id: "",
                    comments: "",
                },
            ],
        },
    },


];


